__turbopack_context__.v({
  "cardGroupCarousel": "BlockPersonalizedRecipes-module-scss-module__ye-VCa__cardGroupCarousel",
  "carousel": "BlockPersonalizedRecipes-module-scss-module__ye-VCa__carousel",
  "ctaContainer": "BlockPersonalizedRecipes-module-scss-module__ye-VCa__ctaContainer",
  "ctaDesktop": "BlockPersonalizedRecipes-module-scss-module__ye-VCa__ctaDesktop",
  "ctaMobile": "BlockPersonalizedRecipes-module-scss-module__ye-VCa__ctaMobile",
  "fade-in": "BlockPersonalizedRecipes-module-scss-module__ye-VCa__fade-in",
  "flushBottom": "BlockPersonalizedRecipes-module-scss-module__ye-VCa__flushBottom",
  "flushTop": "BlockPersonalizedRecipes-module-scss-module__ye-VCa__flushTop",
  "inlineIntroContent": "BlockPersonalizedRecipes-module-scss-module__ye-VCa__inlineIntroContent",
  "inlineIntroContentInner": "BlockPersonalizedRecipes-module-scss-module__ye-VCa__inlineIntroContentInner",
  "inlineIntroSmall": "BlockPersonalizedRecipes-module-scss-module__ye-VCa__inlineIntroSmall",
  "isLoading": "BlockPersonalizedRecipes-module-scss-module__ye-VCa__isLoading",
  "loadingMessage": "BlockPersonalizedRecipes-module-scss-module__ye-VCa__loadingMessage",
  "lockupContainer": "BlockPersonalizedRecipes-module-scss-module__ye-VCa__lockupContainer",
  "lockupInner": "BlockPersonalizedRecipes-module-scss-module__ye-VCa__lockupInner",
  "root": "BlockPersonalizedRecipes-module-scss-module__ye-VCa__root",
});
